export default __webpack_public_path__ + "static/media/bsc_task.c5bdd6f2.svg";